
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class ReportSaleTaxTreeTaxDialog extends Serenity.EntityDialog<ReportSaleTaxTreeTaxRow, any> {
        protected getFormKey() { return ReportSaleTaxTreeTaxForm.formKey; }
        protected getIdProperty() { return ReportSaleTaxTreeTaxRow.idProperty; }
        protected getLocalTextPrefix() { return ReportSaleTaxTreeTaxRow.localTextPrefix; }
        protected getNameProperty() { return ReportSaleTaxTreeTaxRow.nameProperty; }
        protected getService() { return ReportSaleTaxTreeTaxService.baseUrl; }
        protected getDeletePermission() { return ReportSaleTaxTreeTaxRow.deletePermission; }
        protected getInsertPermission() { return ReportSaleTaxTreeTaxRow.insertPermission; }
        protected getUpdatePermission() { return ReportSaleTaxTreeTaxRow.updatePermission; }

        protected form = new ReportSaleTaxTreeTaxForm(this.idPrefix);

    }
}